import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ImageCroppedEvent,
  ImageTransform,
  base64ToFile,
  Dimensions
} from 'ngx-image-cropper';

@Component({
  selector: 'app-image-cropper-popup-component',
  templateUrl: './image-cropper-popup.component.html',
  styleUrls: ['./image-cropper-popup.component.scss']
})
export class ImageCropperPopupComponent  {
  
  @Input() public data: any;
  public imageChangedEvent = '';
  public croppedImageBase64: string = null;
  public croppedImageFile: File;
  public canvasRotation = 0;
  public rotation = 0;
  public scale = 1;
  public showCropper = false;
  public containWithinAspectRatio = false;
  public transform: ImageTransform = {};

  public constructor(public readonly activeModal: NgbActiveModal) {}

  public fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  public imageCropped(event: ImageCroppedEvent): void {
    
    if (event.blob) {
      const fileName = `cropped-image-${Date.now()}.png`;
      this.croppedImageFile = new File([event.blob], fileName, { type: event.blob.type });
      
      this.blobToBase64(event.blob).then(base64 => {
        this.croppedImageBase64 = base64;
      }).catch(err => {
        console.error('Error converting Blob to Base64:', err);
      });
    } else {
      console.error('No blob found in cropped image event');
    }
  }
  
  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  public imageLoaded(): void {
    this.showCropper = true;
  }

  public cropperReady(sourceImageDimensions: Dimensions): void {
    //   console.log('Cropper ready', sourceImageDimensions);
  }

  public loadImageFailed(): void {
    //   console.log('Load failed');
  }

  public rotateLeft(): void {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  public rotateRight(): void {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  private flipAfterRotate(): void {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
  }

  public flipHorizontal(): void {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH
    };
  }

  public flipVertical(): void {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV
    };
  }

  public resetImage(): void {
    this.scale = 1;
    this.rotation = 0;
    this.canvasRotation = 0;
    this.transform = {};
  }

  public zoomOut(): void {
    this.scale -= 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  public zoomIn(): void {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  public toggleContainWithinAspectRatio(): void {
    this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }

  public updateRotation(): void {
    this.transform = {
      ...this.transform,
      rotate: this.rotation
    };
  }
  public submit(): void {
    this.activeModal.close({
      croppedImageBase64: this.croppedImageBase64,
      croppedImageFile: this.croppedImageFile
    });
  }

  public ngOnInit(): void {
    if (this.data && this.data.file) {
      this.fileChangeEvent(this.data.file);
    }
  }
}
